import { useEffect, useRef, useState, type ReactNode } from "react";

/** Click-to-open popover anchored to its trigger; closes on outside click and Escape. */
export function Popover({ trigger, children, className = "menu" }: {
  trigger: (props: { open: boolean; toggle: () => void }) => ReactNode;
  children: (close: () => void) => ReactNode;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onDown); document.removeEventListener("keydown", onKey); };
  }, [open]);
  return (
    <div ref={ref} className="menu-anchor">
      {trigger({ open, toggle: () => setOpen((o) => !o) })}
      {open && <div className={className} role="menu">{children(() => setOpen(false))}</div>}
    </div>
  );
}
